<template lang="html">
  <div class="user-profile" :class="theClass" @click="click">
    <v-row class="size-2">
      <v-col :md="4">
        <v-card class="p-3">
          <v-avatar
            :name="user.name"
            :about="user.profile + '<br>' + user.focus"
            :image="user.avatar_old"
            class="p-3"
          >
          </v-avatar>
          <v-list class="user-profile mt-3">
            <v-text tag="div"
              ><b>Experiência:</b>
              <span>{{ user.years_experience }} anos</span></v-text
            >
            <v-text
              v-if="
                user.profile === 'Desenvolvedor' &&
                  user.vibbrante_type == 'vibbrante'
              "
              tag="div"
              ><b>Qualidade de código:</b>
              <span>
                {{ user.code_quality }}
                <v-helper
                  class="text-muted"
                  title="Qualidade de código"
                  placement="top"
                >
                  Para os candidatos do perfil Desenvolvedor, realizamos uma
                  análise do código desenvolvido durante o seu teste técnico,
                  para verificar a qualidade. Fazemos essa análise através da
                  ferramenta CODACY, que gera uma nota de A até F. Apenas passam
                  e se tornam Vibbrantes aqueles profissionais que tiram A, B ou
                  C nessa avaliação.
                </v-helper>
              </span>
            </v-text>
            <v-text tag="div" v-if="user.profile === 'Designer'"
              ><b>Portfólio:</b>
              <v-link
                href="https://app.vibbra.com.br/#/client/register"
                target="_blank"
                >Cadastre-se para ver</v-link
              ></v-text
            >
            <v-text tag="div"
              ><b>Valor/hora:</b>
              <span
                ><v-link
                  href="https://app.vibbra.com.br/#/client/register"
                  target="_blank"
                  >Cadastre-se para ver</v-link
                ></span
              ></v-text
            >
            <v-text tag="div"
              ><b>Inglês:</b> <span>{{ user.english_level }}</span></v-text
            >
            <v-text tag="div"
              ><b>Clientes estrangeiros:</b>
              <span v-if="user.exp_international_client === true">Sim</span>
              <span v-else>Não</span>
            </v-text>
            <v-text tag="div"
              ><b>Cidade:</b>
              <span>{{ user.city }}/{{ user.state }} </span></v-text
            >
            <v-text tag="div"
              ><b>Idade:</b> <span>{{ user.age }} anos</span></v-text
            >
            <v-text tag="div"
              ><b>Código do profissional:</b>
              <span>
                {{ user.id }}
                <v-helper
                  class="text-muted"
                  title="Código do profissional"
                  placement="top"
                >
                  Código utilizado para que consiga enontrar esse profissional
                  em específico na Busca. Para isso, basta acessar a tela de
                  Busca, no menu Profissionais > Buscar, abrir as Opções
                  Avançadas e inserir o código no campo "Código do
                  profissional", clicando em Filtrar.
                </v-helper>
              </span>
            </v-text>
            <v-button @click="toSignUp()" class="primary block"
              >Ver o perfil completo</v-button
            >
          </v-list>
          <v-stars
            :stars="user.score"
            slot="top-right"
            v-if="user.vibbrante_type == 'vibbrante'"
          ></v-stars>
          <small
            slot="top-left"
            class="badge badge-success"
            v-if="user.vibbrante_type == 'vibbrante'"
            >{{ user.vibbrante_type }}!</small
          >
          <small
            slot="top-left"
            class="badge badge-light"
            v-if="user.vibbrante_type == 'freelancer'"
            >{{ user.vibbrante_type }}</small
          >
        </v-card>
      </v-col>
      <v-col :md="8">
        <v-card class="p-3">
          <v-tabs class="mb-3 nav-tabs">
            <v-button href="#tab-about" class="active">Sobre</v-button>
            <v-button href="#tab-skill">Habilidades</v-button>
            <v-button
              href="#tab-scores"
              v-if="user.vibbrante_type == 'vibbrante'"
              >Avaliação Vibbra</v-button
            >
          </v-tabs>
          <v-div class="tab-content">
            <v-content class="tab-pane fade" id="tab-skill" role="tabpanel">
              <v-text
                >Habilidades que o profissional possui experiência comprovada de
                mercado.</v-text
              >
              <v-row :size="2">
                <v-col :xs="12" v-for="skill in user.vibbrante_skills">
                  <v-text class="m-0">{{ skill.description }}</v-text>
                  <v-progress :percent="skill.score" />
                </v-col>
              </v-row>
            </v-content>
            <v-content
              class="mb-3 tab-pane show active"
              id="tab-about"
              role="tabpanel"
            >
              <v-text class="text-about">
                {{ user.about | trim }}
              </v-text>
              <v-divider line v-if="user.other_tags.length > 0" />
              <v-text v-if="user.other_tags.length > 0"
                >Tags relacionadas ao perfil do profissional.</v-text
              >
              <v-badge
                class="mr-2 mb-2 primary"
                v-for="t in user.other_tags"
                size="3"
                >{{ t }}</v-badge
              >
            </v-content>
            <v-content
              class="mb-3 tab-pane fade"
              id="tab-scores"
              role="tabpanel"
              v-if="user.vibbrante_type == 'vibbrante'"
            >
              <v-text
                >Resultado do Vibbrante no
                <v-link
                  href="http://vibbra.com.br/selecao_vibbra.pdf"
                  target="_blank"
                  >processo de seleção</v-link
                >
                da Vibbra</v-text
              >
              <v-button @click="toSignUp()" class="primary block"
                >Cadastre-se para ter acesso</v-button
              >
            </v-content>
            <v-content class="tab-pane fade" id="tab-feedback" role="tabpanel">
              <v-text
                >Feedbacks recebidos de contratantes na plataforma.</v-text
              >
              <v-button @click="toSignUp()" class="primary block"
                >Cadastre-se para ter acesso</v-button
              >
            </v-content>
          </v-div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import config from '../../configs/js/config';

import FilterBar from './filter-bar';

export default {
  components: {
    'v-filter-bar': FilterBar,
  },
  props: {
    user: Object,
  },
  methods: {
    click() {
      this.$emit('click');
    },
    goToVibbrant() {},
    toSignUp() {
      const win = window.open(
        'https://app.vibbra.com.br/#/client/register',
        '_blank'
      );
      win.focus();
    },
  },
  computed: {
    theClass() {
      return 'type-';
    },
  },
};
</script>

<style lang="scss">
.user-profile {
  .user-row-info {
    .col {
      text-align: center;
      background-color: gray(100);
      div.text {
        font-size: 1.4em;
      }
      small.text {
        line-height: 1em;
        font-size: 0.8em;
        display: block;
      }
    }
  }
  .profile-bg {
    height: 130px;
    background: gray(200);
    margin-bottom: -90px;
  }
  .avatar .avatar-image {
    width: 100px;
  }
  .user-about {
    padding: 1em;
  }
  .text-about {
    white-space: pre-wrap;
  }
  @each $profile in $profiles {
    &.type-#{$profile} {
      .profile-bg {
        background-color: color($profile);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/vibbrant-profile.vue